import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Divider } from '@material-ui/core';
import { Toolbar, Card, Members, Repositories } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.white,
    overflow: 'hidden'
  },
  overflow: {
    overflow: 'auto',
    height: 'calc(100% - 68px)',
    paddingBottom: theme.spacing(3)
  },
  mt: {
    marginTop: theme.spacing(3)
  }
}));

const GroupPage = props => {
  const { onBack, onDeleteGroup, onEditGroup, onAddMember, onRemoveMembers, onSendMailStudents, onShareRepository, onRefresh, group, className, ...rest } = props;

  const classes = useStyles();

  const handleRefresh = (group) => () => {
    onRefresh && onRefresh(group);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar
        group={group.values}
        handleRefresh={handleRefresh}
        onBack={onBack}
        open={group.open}
      />
      <Divider />
      <div className={classes.overflow}>
        {group.open &&
          <React.Fragment>
            <Card
              group={group.values}
              onDeleteGroup={onDeleteGroup}
              onEditGroup={onEditGroup}
            />
            <Members
              className={classes.mt}
              group={group.values}
              onAddMember={onAddMember}
              onRemoveMembers={onRemoveMembers}
              onSendMailStudents={onSendMailStudents}
              title="Members"
            />
            <Repositories
              className={classes.mt}
              group={group.values}
              onShareRepository={onShareRepository(group.values.classID)}
              title="Share My Repositories"
            />
          </React.Fragment>
        }
      </div>
    </div>
  );
};

GroupPage.propTypes = {
  className: PropTypes.string,
  group: PropTypes.object,
  onAddMember: PropTypes.func,
  onBack: PropTypes.func,
  onDeleteGroup: PropTypes.func,
  onEditGroup: PropTypes.func,
  onRefresh: PropTypes.func,
  onRemoveMembers: PropTypes.func,
  onSendMailStudents: PropTypes.func,
  onShareRepository: PropTypes.func
};

export default GroupPage;
